import React from "react";

import { useLabels } from "../../../hooks/useLabels";

import { IconButton } from "../../icon-button";

import { Header } from "../header";

import { labels } from "./labels";

function PhotoPreviewHeaderLeft({ onBack }: { onBack(): void }) {
	return (
		<IconButton
			className="photo-selection-screen__header__back"
			iconName="arrow-left"
			onClick={() => onBack()}
		/>
	);
}

function PhotoPreviewHeaderRight({ onRemove, onInfo }: { onRemove(): void; onInfo(): void }) {
	const [[removeLabel, infoLabel], areLabelsLoading] = useLabels([labels.remove, labels.info]);

	if (areLabelsLoading) return null;

	return (
		<>
			<IconButton iconName="info" title={infoLabel} onClick={onInfo} />
			<IconButton iconName="bin" title={removeLabel} onClick={onRemove} />
		</>
	);
}

export function PhotoPreviewHeader({
	onBack,
	onRemove,
	onInfo,
}: {
	onBack(): void;
	onRemove(): void;
	onInfo(): void;
}) {
	return (
		<Header
			left={<PhotoPreviewHeaderLeft onBack={onBack} />}
			right={<PhotoPreviewHeaderRight onRemove={onRemove} onInfo={onInfo} />}
		/>
	);
}
